import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "../i18n";

const KEY = "nv_cookie_consent";

export const CookieConsent = () => {
  const { t } = useLang();
  const c = t.cookie;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie notice"
      data-testid="cookie-consent"
      className="fixed inset-x-3 bottom-3 z-[45] border border-[#C8D3DB] bg-[#FFFFFF]/95 p-4 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.8)] backdrop-blur-xl sm:inset-x-auto sm:bottom-6 sm:left-6 sm:max-w-sm sm:p-5"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-start gap-3">
          <Cookie size={20} className="mt-0.5 shrink-0 text-[#0F5C8C]" />
          <p className="text-sm leading-relaxed text-[#41535F]">
            {c.text}{" "}
            <Link to="/privacy" data-testid="cookie-privacy-link" className="font-medium text-[#0F5C8C] underline-offset-2 hover:underline">{c.learn}</Link>
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <button type="button" onClick={() => decide("declined")} data-testid="cookie-decline" className="inline-flex min-h-[44px] flex-1 items-center justify-center border border-[#C8D3DB] px-4 text-sm font-semibold text-[#0E1B24] transition-colors hover:border-[#0F5C8C]">
            {c.decline}
          </button>
          <button type="button" onClick={() => decide("accepted")} data-testid="cookie-accept" className="inline-flex min-h-[44px] flex-1 items-center justify-center bg-gradient-brand px-5 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5">
            {c.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
